
import PrimaryMultiSelectModal from "@components/modals/select-modals/PrimaryMultiSelectModal";
import { useGetAllSaleTargetsQuery } from "@states/sale-target/sale-target.api";
import { TSaleTarget } from "@type-defs/sale-target/TSaleTarget";
import { Dispatch, SetStateAction } from "react";

const ProductTargetColumns = [
    {
        name: "Start Date",
        selector: (row: TSaleTarget) => row.format_start_date,
        right: true,
    },
    {
        name: "End Date",
        selector: (row: TSaleTarget) => row.format_end_date,
        right: true,
    },

    {
        name: 'Sale Person Name',
        selector: (row: TSaleTarget) => row.username
    },


    {
        name: 'region_name',
        selector: (row: TSaleTarget) => row.region_name
    },


]

const ProductTargetColumnNames = [
    "Start Date",
    "End Date",
];

const SaleTargetReportFilter = ({
    setProductTargetIds }: { setProductTargetIds: Dispatch<SetStateAction<(string | number)[]>> }) => {


    return (
        <div className="w-[15rem]">

            <PrimaryMultiSelectModal
                label="All Product Targets"
                columns={ProductTargetColumns}
                columnNames={ProductTargetColumnNames}
                idToSelect={'sales_target_id'}
                useGetAllQuery={useGetAllSaleTargetsQuery}
                keyToSearch="username"
                setSelectedIds={setProductTargetIds}

            />

        </div>
    )
}

export default SaleTargetReportFilter
